export const PREVENTABLE_CLOSE_CLASSES = [
  '.modal',
  '.sign-up-drawer',
  '.sign-in-drawer',
  '.authenticated-modal',
  '.inventory-heart-tooltip',
];
